<template>
  <div class="header">
    <div class="header_name">
      <div class="logo_mark"></div>
      <h1 class="name">金创视频智慧监控大屏</h1>
    </div>

    <div class="header_center">
      <div class="ctrl_group">
        <div class="ctrl_item">
          <span class="ctrl_label">轮巡</span>
          <SwitchedSmall @change="switchLoopChange" :defaultChecked="isLoop" checkedInfo="ON" uncheckedInfo="OFF"
            :disabled="false"></SwitchedSmall>
        </div>
        <div class="ctrl_divider"></div>
        <div class="ctrl_item">
          <span class="ctrl_label">画面</span>
          <div class="ctrl_select" @click="toggleDropdown" ref="selectWrap">
            <span class="select_text">{{ pageSize }} 画面</span>
            <svg class="select_arrow" :class="{ open: dropdownOpen }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
            <transition name="dropdown">
              <div class="select_dropdown" v-if="dropdownOpen">
                <div class="select_option" :class="{ active: pageSize == '16' }" @click="selectPageSize('16')">16 画面</div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <div class="header_actions">
      <div class="action_btn screen" @click="fullScreen" title="全屏">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
        </svg>
      </div>
      <div class="user_wrap" ref="userWrap">
        <div class="user_trigger" @click="toggleUserMenu">
          <img class="heading" src="@/assets/img/headimg.jpg" />
          <svg class="user_arrow" :class="{ open: userMenuOpen }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
        <transition name="menu">
          <div class="user_menu" v-if="userMenuOpen">
            <div class="user_info">
              <img class="menu_avatar" src="@/assets/img/headimg.jpg" />
              <span class="menu_name">{{ user_info.user_nickname }}</span>
            </div>
            <div class="menu_divider"></div>
            <div class="menu_item logout" @click="loginOut">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              <span>退出登录</span>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import SwitchedSmall from './../Switched/SwitchedSmall';
export default {
  name: 'HeaderCmp',
  components: {
    SwitchedSmall
  },
  data() {
    return {
      dropdownOpen: false,
      userMenuOpen: false
    }
  },
  computed: {
    user_info() {
      return this.$store.state.user_info || {};
    },
    isLoop() {
      return this.$store.state.isLoop;
    },
    pageSize() {
      return this.$store.state.page_size;
    },
  },
  mounted() {
    document.addEventListener('click', this.handleDocClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocClick);
  },
  methods: {
    switchLoopChange(e) {
      this.$store.dispatch("doChangeLoop", e);
    },
    fullScreen() {
      this.$emit('onFullScreen')
    },
    changeSelect(e) {
      this.$store.dispatch("doChangePageSize", e.target.value);
    },
    loginOut() {
      this.userMenuOpen = false;
      this.$store.dispatch("doLoginOut", this);
    },
    toggleDropdown(e) {
      e.stopPropagation();
      this.dropdownOpen = !this.dropdownOpen;
      this.userMenuOpen = false;
    },
    selectPageSize(size) {
      this.$store.dispatch("doChangePageSize", size);
      this.dropdownOpen = false;
    },
    toggleUserMenu(e) {
      e.stopPropagation();
      this.userMenuOpen = !this.userMenuOpen;
      this.dropdownOpen = false;
    },
    handleDocClick() {
      this.dropdownOpen = false;
      this.userMenuOpen = false;
    }
  }
}
</script>

<style scoped>
.header {
  width: 100%;
  height: 64px;
  background: rgba(11, 17, 32, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  position: relative;
  z-index: 10;
  flex-shrink: 0;
}

.header_name {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo_mark {
  width: 6px;
  height: 24px;
  background: linear-gradient(180deg, #3b82f6, #60a5fa);
  border-radius: 3px;
}

.header_name .name {
  color: #e2e8f0;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 1px;
}

/* 中间控制区 */
.header_center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.ctrl_group {
  display: flex;
  align-items: center;
  gap: 0;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 4px 16px;
  height: 44px;
}

.ctrl_item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 10px;
}

.ctrl_label {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.ctrl_divider {
  width: 1px;
  height: 20px;
  background: rgba(255, 255, 255, 0.08);
}

/* 自定义下拉 */
.ctrl_select {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: background 0.2s;
}

.ctrl_select:hover {
  background: rgba(255, 255, 255, 0.05);
}

.select_text {
  font-size: 13px;
  color: #e2e8f0;
  font-weight: 500;
  min-width: 48px;
  text-align: center;
}

.select_arrow {
  width: 14px;
  height: 14px;
  color: #64748b;
  transition: transform 0.3s;
}

.select_arrow.open {
  transform: rotate(180deg);
}

.select_dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: rgba(30, 41, 59, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 4px;
  min-width: 100px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  z-index: 200;
}

.select_option {
  padding: 8px 12px;
  font-size: 13px;
  color: #94a3b8;
  border-radius: 6px;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s;
}

.select_option:hover,
.select_option.active {
  background: rgba(59, 130, 246, 0.15);
  color: #3b82f6;
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.2s ease;
}

.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-6px);
}

/* 右侧操作区 */
.header_actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.action_btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #94a3b8;
}

.action_btn:hover {
  background: rgba(59, 130, 246, 0.15);
  border-color: rgba(59, 130, 246, 0.3);
  color: #3b82f6;
  box-shadow: 0 0 16px rgba(59, 130, 246, 0.2);
}

.action_btn svg {
  width: 18px;
  height: 18px;
}

/* 用户菜单 */
.user_wrap {
  position: relative;
}

.user_trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 6px 4px 4px;
  border-radius: 24px;
  cursor: pointer;
  transition: all 0.3s;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.user_trigger:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.12);
}

.user_trigger .heading {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
}

.user_arrow {
  width: 14px;
  height: 14px;
  color: #64748b;
  transition: transform 0.3s;
}

.user_arrow.open {
  transform: rotate(180deg);
}

.user_menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 180px;
  background: rgba(30, 41, 59, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 8px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  z-index: 200;
}

.user_info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
}

.menu_avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.menu_name {
  font-size: 13px;
  color: #e2e8f0;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 110px;
}

.menu_divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
  margin: 4px 8px;
}

.menu_item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 13px;
  color: #94a3b8;
}

.menu_item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.menu_item.logout:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.menu_item svg {
  width: 16px;
  height: 16px;
}

.menu-enter-active,
.menu-leave-active {
  transition: all 0.2s ease;
}

.menu-enter,
.menu-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
